import * as PropTypes from 'prop-types';
import * as React from 'react';
import { IDegradationInfoSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { IContext } from '../../store';
import { logComponentError } from '../../utils/log_component_error';
import { FOfferType, getOfferType } from '../../utils/offer_type';
import { checkFlocktoryLoad } from '../../utils/flocktory';
import { BuildingGarageLandCardContainer } from './buildingGarageLand/container';
import { OtherCommercialCardContainer } from './otherCommercialCard/container';

export interface ICommercialOfferCardPageProps {
  context: IContext;
}

export interface ICommercialOfferCardPageStoreProps {
  offer: IOfferSchema;
  degradationInfo: IDegradationInfoSchema | null;
}

export interface ICommercialOfferCardPageDispatchProps {
  setKeyPushNotificationValue(value: boolean): void;
  fetchAgent(): void;
}

export type IProps = ICommercialOfferCardPageProps &
  ICommercialOfferCardPageDispatchProps &
  ICommercialOfferCardPageStoreProps;

export class CommercialOfferCardPage extends React.Component<IProps, {}> {
  public context: IContext;

  public static childContextTypes = {
    config: PropTypes.object,
    httpApi: PropTypes.object,
    logger: PropTypes.object,
    makeRequest: PropTypes.func,
    telemetry: PropTypes.object,
  };

  public getChildContext() {
    return {
      config: this.props.context.config,
      httpApi: this.props.context.httpApi,
      logger: this.props.context.logger,
      makeRequest: this.props.context.makeRequest,
      telemetry: this.props.context.telemetry,
    };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logComponentError({
      error,
      errorInfo,
      logger: this.props.context.logger,
    });
  }

  public componentDidMount() {
    const { setKeyPushNotificationValue, degradationInfo } = this.props;

    if (degradationInfo && degradationInfo.agent) {
      this.props.fetchAgent();
    }

    checkFlocktoryLoad()
      .then(flocktory => {
        flocktory
          .getSubscriptionStatus()
          .then(response => {
            /**
             * Если flocktory вернули поле subscribed и оно равно false,
             * значит текущий пользователь не подписан на пуши и нужно показать попап
             */
            if ('subscribed' in response && !response.subscribed) {
              setKeyPushNotificationValue(true);
            }
          })
          .catch(e => {
            throw e;
          });
      })
      .catch(e => {
        throw e;
      });
  }

  public render() {
    const offerType = getOfferType(this.props.offer);

    return this.renderCard(offerType);
  }

  private renderCard = (offerType: FOfferType) => {
    if ([FOfferType.Building, FOfferType.Garage, FOfferType.CommercialLand].includes(offerType)) {
      return <BuildingGarageLandCardContainer context={this.props.context} />;
    }

    return <OtherCommercialCardContainer context={this.props.context} />;
  };
}
